import React, { useState } from "react";
import Slider from "react-slick";
import "./Testimonial.css";
import images from "../../../../utilities/images/images";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TestimonialModal from "./TestimonialModal";

const Testimonial = ({ data }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);

  const handleOpenModal = (elem) => {
    setSelectedTestimonial(elem);
    setShowModal(true);
  };

  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="testimonial-wrapper">
      <p class="testimonial-text-element">What our students say</p>
      <Slider {...settings}>
        {data?.map((elem) => (
          <div key={elem.id} className="testimonial-slide">
            <div className="testimonial-item">
              <div className="testimony-header">
                <div className="student-details">
                  <img src={elem.image} alt="student-image" />
                  <div className="testimony-name-target">
                    <div className="testimony-name">{elem.student_name}</div>
                    <div className="testimony-target">
                      {elem.target}(AIR {elem.AIR})
                    </div>
                  </div>
                </div>
                <img
                  src={images.double_quotes}
                  className="double_quotes"
                  alt="double-quotes-icon"
                />
              </div>
              <div className="testimony-divider"></div>
              <div className="testimony-data">
                {elem.video_id && (
                  <div
                    className="testimony-video"
                    onClick={() => handleOpenModal(elem)}
                  >
                    <img
                      src={elem.image}
                      className="video-thumnail-img"
                      alt="student-image"
                      style={elem.video_id && { opacity: "0.5" }}
                    />
                    <img
                      src={images.video_player_icon}
                      className="video-player-icon"
                      alt="video-player-icon"
                    />
                  </div>
                )}


                <div
                  className="testimony-descript"
                  style={elem.video_id ? { maxWidth: "22.625rem" } : undefined}
                >
                  {" "}
                  {elem.testimonials.length > 200 ? (
                    <>
                      {elem.testimonials.slice(0, elem.video_id ? 140 : 180)}...
                      <span
                        className="read-more-text"
                        onClick={() => handleOpenModal(elem)}
                      >
                        {" "}
                        Read More
                      </span>
                    </>
                  ) : (
                    elem.testimonials
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
      <TestimonialModal
        show={showModal}
        onHide={() => setShowModal(false)}
        selectedTestimonial={selectedTestimonial}
      />
    </div>
  );
};

export default Testimonial;
